import { render, staticRenderFns } from "./model-r1-faq.vue?vue&type=template&id=1779a4b6&scoped=true&"
import script from "./model-r1-faq.vue?vue&type=script&lang=js&"
export * from "./model-r1-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1779a4b6",
  null
  
)

export default component.exports